import { clearCart } from '../../service/ajax';
import { orderUpdateState } from '../../service/order';

const modalCartRemove = $('#modalRemoveInCart');

document.addEventListener('DOMContentLoaded', () => {
  $(document).on('click', 'button[data-cart-action="remove"]', (e) => {
    modalCartRemove.modal('show');
    modalCartRemove.data(
      'productId',
      $(e.currentTarget).closest('[data-cart-product-id]').data('cartProductId'),
    );
  });

  $('[data-card-remove]').on('click', (e) => {
    removeProductFromCart(e);
  });

  const smCart = document.querySelector('.header-account-link');

  smCart.addEventListener('SmCart:init', () => {
    $('[data-card-remove]').on('click', (e) => {
      removeProductFromCart(e);
    });
  });
});

function removeProductFromCart(e) {
  const productId = getId(e.currentTarget);

  /** @type {{ productId: number }} */
  modalCartRemove.modal('hide');

  orderUpdateState(true);

  if (productId !== 0) {
    window.promiseQueue.add('change-cart', async () => {
      removeAction(productId).then((response) => {
        response.data = typeof response.data === 'string'
          ? JSON.parse(response.data) : response.data;
        document.updateCartIcon(response.data?.countItemsInCart);

        if (window.Dio.SHOP.CART.getAllProductsCount() !== 1) {
          window.Dio.SHOP.CART_PREORDER.removeById(productId);
          window.Dio.SHOP.CART_WISHLIST.removeById(productId);
          fadeOutProduct(productId);

          if (response.data.total === 0) {
            removeAll();
          }
        } else {
          window.location.reload();
        }

        orderUpdateState(false);
      })
        .catch((error) => {
          document.modalMessageErrorShow();
          // eslint-disable-next-line no-console
          console.warn(error);
        });
    });
  } else {
    removeSelected();
  }
}

function fadeOutProduct(productId) {
  const cartItem = $(`[data-cart-product-id=${productId}]`);
  cartItem.fadeOut(400, () => {
    window.Dio.SHOP.CART_PREORDER.removeById(Number(productId));
    window.Dio.SHOP.CART.smCart.update(window.Dio.SHOP.CART.getAllProductsCount());
    cartItem.remove();
  });
}

function removeAll() {
  window.Dio.SHOP.CART.clear();
  const temp = $('.shop-cart .template');
  temp.animate({
    height: 280,
  });
  const message = TempEmptyCart();
  temp.html(message);
}

async function removeSelected() {
  const AllProductsCount = window.Dio.SHOP.CART.getShortAllProducts();
  const checkedProducts = window.Dio.SHOP.CART
    .getAllProducts().filter(product => product.wish === true);

  const productsAjax = checkedProducts.map(product => product.id);

  orderUpdateState(true);

  clearCart(productsAjax).then((response) => {
    Array.prototype.filter.call(window.Dio.SHOP.CART_PREORDER.products, (product) => {
      const cartItem = $(product.product);
      if (response.data.total === 0) {
        removeAll();
      } else {
        cartItem.fadeOut(400, () => {
          window.Dio.SHOP.CART_PREORDER.removeById(Number(cartItem[0].dataset.cartProductId));
          cartItem.remove();
        });
      }
    });
    window.Dio.SHOP.CART.smCart.update(window.Dio.SHOP.CART.getAllProductsCount());
    orderUpdateState(false);
  });
}

export function TempEmptyCart() {
  return '<div class="cart-block template">\n'
    + '\n'
    + '        <h1 class="title-h1 py-3">\n'
    + '    Корзина\n'
    + '</h1>\n'
    + '<div class="row">\n'
    + '\n'
    + '            <div class="col">\n'
    + '            <div class="title-h3 pt-3 mb-3">\n'
    + '                Ваша корзина пуста\n'
    + '            </div>\n'
    + '            <div class="mb-3">\n'
    + '                Для оформления заказа добавьте в корзину как минимум один товар. <br>\n'
    + '                Если хотите что-либо приобрести, <a href="/catalog">перейдите в каталог</a>.\n'
    + '            </div>\n'
    + '        </div>\n'
    + '    \n'
    + '\n'
    + '</div>\n'
    + '\n'
    + '    </div>';
}

export const removeAction = async (productId) => {
  const CARD_REMOVE_URI = '/v1/cart/remove';
  const data = {
    productId,
  };
  const action = await window.axios
    .put(CARD_REMOVE_URI, data);
  /** @param {{ countItemsInCart: number }} response.data */
  return action;
};

const getId = (target) => {
  if (target.closest('[data-product-id]') !== null) {
    if (target.closest('[data-product-id]').dataset?.productId) {
      return Number(target.closest('[data-product-id]').dataset.productId);
    }
  } else {
    return (target.dataset.cardRemove)
      ? Number(target.dataset.cardRemove)
      : Number(target.closest('[data-product-id]').dataset.productId);
  }

  return 0;
};
